
import React, {useContext, useEffect, useState} from "react";
import usePA_GlobalStore from "../../Services/ZustandGlobalStore";
import {PAContext} from "../../Services/PAContext";
import {
    Button,
    Dialog, DialogActions,
    DialogContent,
    FormControl,
    InputLabel, LinearProgress,
    MenuItem,
    Select,
    TextField
} from "@mui/material";
import currencyList from "../../sampleData/currencyList";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";




function PersonalBudget({ isOpen, onClose }) {

    const {PA_GlobalObject, set_PA_GlobalObject} = usePA_GlobalStore();

    const { dataArray } = useContext(PAContext);
    const { Account } = dataArray;

    const [ attendeeBudget, setAttendeeBudget ] = useState(PA_GlobalObject.Planning.attendees.find(_att => _att.id === Account.id)?.budget || {} );
    const [totalBudgetAmount, setTotalBudgetAmount] =
        useState(PA_GlobalObject?.Planning?.attendees
            ?.find(_att => _att?.id === Account?.id)
            ?.budget?.total_budget ?? 0);
    const [totalBudgetCurrency, setTotalBudgetCurrency] =
        useState(
            PA_GlobalObject?.Planning?.attendees
                ?.find(a => a?.id === Account?.id)
                ?.budget?.currency ?? "USD"
        );
    // Handle currency change
    const handleBudgetCurrencyChange = (event) => {
        setTotalBudgetCurrency(event.target.value);
    };

    function updateTotalBudgetAmount(){

        setAttendeeBudget(prev => {

            return {
                ...prev,
                total_budget: totalBudgetAmount,
                currency: totalBudgetCurrency
            }
        });

        //close the area
        setExpandedTotalBudget(false);
    }

    useEffect(() => {

        console.log("setting the updated budget : ", attendeeBudget);

        set_PA_GlobalObject(prev => {
            const updatedAttendees = prev.Planning.attendees.map(att => {
                if (att.id === Account.id) {
                    return {
                        ...att,
                        budget: { ...att.budget, ...attendeeBudget }  // Merge the new fields
                    };
                }
                return att;
            });

            return {
                ...prev,
                Planning: {
                    ...prev.Planning,
                    attendees: updatedAttendees
                }
            };
        });
    }, [attendeeBudget]);

    const _budget_categories = ['meal', 'lodging', 'activity', 'flight', 'supplies', 'incidentals', 'shopping', 'transportation'];
    const initialCategoryLimits = _budget_categories.reduce((acc, category) => {
        const categoryKey = `${category}_budget`;
        const unitKey = `${category}_budget_unit`;

        acc[categoryKey] = {
            total: attendeeBudget[categoryKey] || 0,
            unit: attendeeBudget[unitKey] || ''
        };

        return acc;
    }, {});

    const [categoryLimits, setCategoryLimits] = useState(initialCategoryLimits);
    useEffect(() => {
        console.log("categoryLimits", categoryLimits);
    }, [categoryLimits]);
    /*
        a function to go through and total a category for this Account
     */
    const [categorySummaries, setCategorySummaries] = useState(() => {
        const summaries = {};

        // Lodging
        const _lodging_list = PA_GlobalObject.Planning.lodging.filter(_lodging =>
            _lodging.attendees?.some(_att => _att.id === Account.id)
        );
        const lodging_total = _lodging_list.reduce((sum, lodging) => {
            const matchingAttendee = lodging.attendees?.find(_att => _att.id === Account.id);
            const cost = matchingAttendee ? parseFloat(matchingAttendee.cost) : 0;
            return sum + (isNaN(cost) ? 0 : cost);
        }, 0).toFixed(2);
        summaries.lodging = {
            list: _lodging_list,
            total: parseFloat(lodging_total)
        };

        //for the meals
        const _meal_list = PA_GlobalObject.Planning.meals.filter(_meal =>
            _meal.attendees?.some(_att => _att.id === Account.id)
        );
        const meal_total = _meal_list.reduce((sum, meal) => {
            const matchingAttendee = meal.attendees?.find(_att => _att.id === Account.id);
            const cost = matchingAttendee ? parseFloat(matchingAttendee.cost) : 0;
            return sum + (isNaN(cost) ? 0 : cost);
        }, 0).toFixed(2);
        summaries.meal = {
            list: _meal_list,
            total: parseFloat(meal_total)
        };

        //for the activities
        const _activity_list = PA_GlobalObject.Planning.activities.filter(_activity =>
            _activity.attendees?.some(_att => _att.id === Account.id)
        );
        const activity_total = _activity_list.reduce((sum, activity) => {
            const matchingAttendee = activity.attendees?.find(_att => _att.id === Account.id);
            const cost = matchingAttendee ? parseFloat(matchingAttendee.cost) : 0;
            return sum + (isNaN(cost) ? 0 : cost);
        }, 0).toFixed(2);
        summaries.activity = {
            list: _activity_list,
            total: parseFloat(activity_total)
        };


        console.log("summaries : ", summaries);

        return summaries;
    });

    const totalUsed = Object.values(categorySummaries).reduce((sum, category) => {
        return sum + (parseFloat(category.total) || 0);
    }, 0);

    const handleBudgetDialogSave = () => {
        // You would save the budget and currency here
        console.log("Budget:", totalBudgetAmount, "Currency:", totalBudgetCurrency);

        setAttendeeBudget(prev => {
            const updatedBudget = _budget_categories.reduce((acc, category) => {
                const categoryKey = `${category}_budget`;
                const unitKey = `${category}_budget_unit`;

                acc[categoryKey] = categoryLimits[categoryKey]?.total || 0;
                acc[unitKey] = categoryLimits[categoryKey]?.unit || 'ea';

                return acc;
            }, {});

            return {
                ...prev,
                ...updatedBudget,
                total_budget: totalBudgetAmount,
                currency: totalBudgetCurrency
            };
        });

        onClose();
    };

    // Simulate the category balances (replace with actual values)
    const getCategoryTotal = (category) => {
        console.log("getCategoryTotal : ", categorySummaries[category]);
        return parseFloat(categorySummaries[category]?.total || 0);
    };

    const getBudgetValue = (category) => {
        const attendee = PA_GlobalObject.Planning.attendees.find(_att => _att.id === Account.id);
        console.log("attendee : ", attendee);

        return attendee?.budget?.[`${category}_budget`] || 0;
    };

    const getProgressColor = (used, limit) => {
        const percent = (used / limit) * 100;
        if (limit === 0) return 'primary';
        if (percent <= 90) return 'success';
        if (percent <= 100) return 'warning';
        return 'error';
    };
    const colorMap = {
        success: '#4caf50',
        warning: '#ff9800',
        error: '#f44336',
        primary: '#2196f3',
        gray: '#eee',
    };

    const [expandedTotalBudget, setExpandedTotalBudget] = useState(null); // to track open edit total budget
    const [expandedCategoryBudget, setExpandedCategoryBudget] = useState(null); // to track open detail sections
    const [expandedCategoryDetails, setExpandedCategoryDetails] = useState(null); // to track open detail sections

    const unitOptions = {
        meal: ['Each Meal', 'Per Day', 'For Entire Event'],
        lodging: ['Each Lodging', 'Per Night', 'For Entire Event'],
        activity: ['Each Activity', 'Per Day', 'For Entire Event'],
        flight: ['Per Flight', 'Roundtrip', 'For Entire Event'],
        supplies: ['Each Receipt', 'Per Day', 'For Entire Event'],
        incidentals: ['Each Receipt', 'Per Day', 'For Entire Event'],
        shopping: ['Each Receipt', 'Per Day', 'For Entire Event'],
        transportation: ['Each Receipt', 'Per Day', 'For Entire Event']
    };

    const categoryIcons = {
        meal: 'icon-fork-knife2',
        lodging: 'icon-bed',
        activity: 'icon-list-heart',
        flight: 'icon-airplane',
        supplies: 'icon-checklist2',
        incidentals: 'icon-flag2',
        shopping: 'icon-bag',
        transportation: 'icon-car',
    };



    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    padding: '16px 24px',
                    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                }}
            >
                {/* Left-aligned name */}
                <Typography variant="h6">
                    {Account.nickname} Budget
                </Typography>

                {/* Right-aligned total + toggle */}
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Typography variant="h6" sx={{ whiteSpace: 'nowrap' }}>
                        {totalBudgetCurrency} {parseFloat(totalBudgetAmount || 0).toFixed(2)}
                    </Typography>
                    <IconButton
                        size="small"
                        sx={{ marginLeft: "8px" }}
                        onClick={() => setExpandedTotalBudget(!expandedTotalBudget)}
                    >
                        {expandedTotalBudget ? (
                            <i className="icon-chevron-up" style={{ fontSize: '14px' }} />
                        ) : (
                            <i className="icon-chevron-down" style={{ fontSize: '14px' }} />
                        )}
                    </IconButton>
                </Box>
                <Box sx={{ mt: 1 }}>
                    <LinearProgress
                        variant="determinate"
                        value={(totalUsed / totalBudgetAmount) * 100}
                        color={getProgressColor(totalUsed, totalBudgetAmount)}
                        sx={{
                            height: 10,
                            borderRadius: 5,
                            border: `2px solid ${getProgressColor(totalUsed, totalBudgetAmount) || '#ccc'}`,
                            '& .MuiLinearProgress-bar': {
                                backgroundColor: getProgressColor(totalUsed, totalBudgetAmount) || '#ccc',
                            }
                        }}
                    />
                    <Typography variant="caption" align="right" display="block" mt={0.5}>
                        Used: {totalBudgetCurrency} {totalUsed.toFixed(2)} / {totalBudgetCurrency} {parseFloat(totalBudgetAmount || 0).toFixed(2)}
                    </Typography>
                </Box>
            </Box>

            <DialogContent dividers>
                {/* Budget Input */}
                {expandedTotalBudget && (
                    <Box
                        sx={{
                            padding: '16px',
                            borderRadius: '8px',
                            marginTop: '16px',
                            marginBottom: '16px',
                        }}
                    >
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            <TextField
                                label="Total Budget"
                                variant="outlined"
                                value={totalBudgetAmount}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const formattedValue = value.replace(/[^\d]/g, '');
                                    setTotalBudgetAmount(formattedValue);
                                }}
                                sx={{ flex: 2 }}
                            />

                            <FormControl sx={{ flex: 1 }}>
                                <InputLabel id="currency-select-label">Currency</InputLabel>
                                <Select
                                    labelId="currency-select-label"
                                    value={totalBudgetCurrency}
                                    label="Currency"
                                    onChange={handleBudgetCurrencyChange}
                                >
                                    {currencyList.map((option) => (
                                        <MenuItem
                                            key={option.code}
                                            value={option.code}
                                            sx={{ fontSize: '12px' }}
                                        >
                                            {option.code} : {option.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    </Box>

                )}

                {/*  Add in a progress bar for each category  */}

                {_budget_categories.map((category) => {
                    const categoryKey = `${category}_budget`;
                    const unitKey = `${category}_budget_unit`;
                    const used = getCategoryTotal(category);
                    const budget = categoryLimits[categoryKey]?.total || 0;
                    const unit = categoryLimits[unitKey] || 'ea';
                    const percent = budget > 0 ? (used / budget) * 100 : 0;
                    const color = getProgressColor(used, budget);

                    return (
                        <Box key={category} sx={{ mb: 3 }}>
                            {/* Header row with icon, label, budget summary, and toggle */}
                            <Box display="flex" justifyContent="space-between" alignItems="center">
                                <Box display="flex" alignItems="center" gap={1}>
                                    <i className={categoryIcons[category]} style={{ fontSize: '20px', color: colorMap[color] || '#000'}} />
                                    <Typography fontWeight="bold" textTransform="capitalize">{category}</Typography>
                                </Box>

                                <Box display="flex" alignItems="center" gap={1}>
                                    <Typography variant="body2" color={`${color}.main`}>
                                        {totalBudgetCurrency} {used.toFixed(2)} / {budget.toFixed(2)}
                                    </Typography>
                                    <IconButton
                                        size="small"
                                        onClick={() =>
                                            setExpandedCategoryBudget(prev => (prev === category ? null : category))
                                        }
                                    >
                                        {expandedCategoryBudget === category ? (
                                            <i className="icon-chevron-up" style={{ fontSize: '14px' }} />
                                        ) : (
                                            <i className="icon-chevron-down" style={{ fontSize: '14px' }} />
                                        )}
                                    </IconButton>
                                </Box>
                            </Box>

                            {/* Progress bar */}
                            <LinearProgress
                                variant="determinate"
                                value={Math.min(percent, 100)}
                                color={color}
                                sx={{
                                    height: 10,
                                    borderRadius: 5,
                                    mt: 1,
                                    border: `2px solid ${colorMap[color] || '#ccc'}`, // Use your dynamic color
                                    '& .MuiLinearProgress-bar': {
                                        backgroundColor: colorMap[color] || '#ccc',
                                        borderRadius: 5,
                                    },
                                }}
                            />

                            {/* Expanded Edit Section */}
                            {expandedCategoryBudget === category && (
                                <>
                                    {/* Controls aligned right */}
                                    <Box display="flex" justifyContent="flex-end" gap={2} mt={2} flexWrap="wrap">
                                        <TextField
                                            label="Limit"
                                            size="small"
                                            value={categoryLimits[categoryKey]?.total || ""}
                                            onChange={(e) => {
                                                const value = parseFloat(e.target.value) || 0;
                                                setCategoryLimits(prev => ({
                                                    ...prev,
                                                    [categoryKey]: {
                                                        ...prev[categoryKey],
                                                        total: value
                                                    }
                                                }));
                                            }}
                                            sx={{ minWidth: 100 }}
                                        />
                                        <FormControl size="small" sx={{ minWidth: 120 }}>
                                            <InputLabel id={`${category}-select-label`}>Unit</InputLabel>
                                            <Select
                                                labelId={`${category}-select-label`}
                                                label="Unit"
                                                value={categoryLimits[categoryKey]?.unit || ""}
                                                onChange={(e) => {
                                                    setCategoryLimits(prev => ({
                                                        ...prev,
                                                        [categoryKey]: {
                                                            ...prev[categoryKey],
                                                            unit: e.target.value
                                                        }
                                                    }));
                                                }}
                                            >
                                                {unitOptions[category].map(opt => (
                                                    <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Box>

                                    {/* List aligned left */}
                                    <Box mt={2}>
                                        {categorySummaries[category]?.list?.length > 0 ? (
                                            categorySummaries[category].list.map((category_item, idx) => (
                                                <Typography key={idx} variant="caption" color="text.secondary" display="block">
                                                    {idx + 1}.{" "}
                                                    {["meal", "activity"].includes(category)
                                                        ? category_item.title
                                                        : category_item.name}{" "}
                                                    — {category_item.attendees.find(_att => _att.id === Account.id)?.cost || 0}
                                                </Typography>
                                            ))
                                        ) : (
                                            <Typography variant="caption" color="text.secondary">
                                                No items available for this category.
                                            </Typography>
                                        )}
                                    </Box>
                                </>
                            )}

                        </Box>
                    );
                })}



            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
                <Button onClick={handleBudgetDialogSave} color="primary">Save</Button>
            </DialogActions>
        </Dialog>
    )



}

export default PersonalBudget;